import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type AnswerLetterRequestMutationVariables = Types.Exact<{
  letterRequestId: Types.Scalars['Int']
  lawyerLetterId: Types.Scalars['Int']
}>

export type AnswerLetterRequestMutation = {
  __typename?: 'Mutation'
  answerLetterRequest: { __typename?: 'LetterRequest'; id: number }
}

export const AnswerLetterRequestDocument = gql`
  mutation AnswerLetterRequest($letterRequestId: Int!, $lawyerLetterId: Int!) {
    answerLetterRequest(letterRequestId: $letterRequestId, lawyerLetterId: $lawyerLetterId) {
      id
    }
  }
`
export type AnswerLetterRequestMutationFn = ApolloReactCommon.MutationFunction<
  AnswerLetterRequestMutation,
  AnswerLetterRequestMutationVariables
>
export function useAnswerLetterRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AnswerLetterRequestMutation,
    AnswerLetterRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AnswerLetterRequestMutation,
    AnswerLetterRequestMutationVariables
  >(AnswerLetterRequestDocument, options)
}
export type AnswerLetterRequestMutationHookResult = ReturnType<
  typeof useAnswerLetterRequestMutation
>
export type AnswerLetterRequestMutationResult =
  ApolloReactCommon.MutationResult<AnswerLetterRequestMutation>
export type AnswerLetterRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AnswerLetterRequestMutation,
  AnswerLetterRequestMutationVariables
>
